export function removeVietnameseTones(str?: string) {
  if (!str) return "";      // 👈 quan trọng
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D");
}